// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) Jupyter Development Team.
 * Distributed under the terms of the Modified BSD License.
 */

.jp-FileBrowser-toolbar
  .jp-ToolbarButtonComponent[data-command='launcher:create'] {
  width: 72px;
  background: var(--jp-brand-color1);
}

.jp-FileBrowser-toolbar
  .jp-ToolbarButtonComponent[data-command='launcher:create']:focus-visible {
  background-color: var(--jp-accept-color-active, var(--jp-brand-color0));
}

.jp-FileBrowser-toolbar
  .jp-ToolbarButtonComponent[data-command='launcher:create']
  .jp-icon3 {
  fill: var(--jp-layout-color1);
}
`, "",{"version":3,"sources":["webpack://./../node_modules/@jupyterlab/launcher-extension/style/base.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;;EAEE,WAAW;EACX,kCAAkC;AACpC;;AAEA;;EAEE,uEAAuE;AACzE;;AAEA;;;EAGE,6BAA6B;AAC/B","sourcesContent":["/*\n * Copyright (c) Jupyter Development Team.\n * Distributed under the terms of the Modified BSD License.\n */\n\n.jp-FileBrowser-toolbar\n  .jp-ToolbarButtonComponent[data-command='launcher:create'] {\n  width: 72px;\n  background: var(--jp-brand-color1);\n}\n\n.jp-FileBrowser-toolbar\n  .jp-ToolbarButtonComponent[data-command='launcher:create']:focus-visible {\n  background-color: var(--jp-accept-color-active, var(--jp-brand-color0));\n}\n\n.jp-FileBrowser-toolbar\n  .jp-ToolbarButtonComponent[data-command='launcher:create']\n  .jp-icon3 {\n  fill: var(--jp-layout-color1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
